var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicro = function SvgMicro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7.65v-4.3C4.5 1.5 6.05 0 8 0s3.5 1.5 3.5 3.35v4.3C11.5 9.5 9.95 11 8 11S4.5 9.5 4.5 7.65ZM7 13.925V15c0 .55.45 1 1 1s1-.45 1-1v-1.075c3.122-.47 5.5-3.106 5.5-6.275V7c0-.55-.45-1-1-1s-1 .45-1 1v.65c0 2.4-2 4.35-4.5 4.35s-4.5-1.95-4.5-4.35V7c0-.55-.45-1-1-1s-1 .45-1 1v.65c0 3.17 2.378 5.806 5.5 6.275Z"
  })));
};
export default SvgMicro;